import { render } from "./PresentationAsPdfButton.vue?vue&type=template&id=ad0e1d92"
import script from "./PresentationAsPdfButton.vue?vue&type=script&lang=js"
export * from "./PresentationAsPdfButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__